<!--

    Copyright (c) 2017-present, Siklu Ltd.
    All rights reserved.

-->
<div class="change-password">
    <h2>{{ 'reset.finish.title' | translate }}</h2>

    <div *ngIf="!key" class="alert alert-danger">{{ 'reset.finish.messages.keymissing' | translate }}</div>

    <div *ngIf="passwordChangeAttempted" [class]="requestResult.isSuccess ? 'alert-success' : 'alert-danger'" class="alert">
        {{ requestResult.message | translate }}
    </div>

    <ng-container *ngIf="key && !passwordChangeAttempted">
        <div class="control-label">{{ 'userManagement.popups.password' | translate }}</div>
        <sui-password-component [config]="newPassword"></sui-password-component>

        <winde-password-strength-bar [passwordToCheck]="newPassword.value"></winde-password-strength-bar>

        <div class="control-label">{{ 'userManagement.popups.confirmPassword' | translate }}</div>
        <sui-password-component [config]="confirmationPassword"></sui-password-component>

        <button (click)="finishReset()" windeGreen>
            {{ 'entity.action.save' | translate }}
        </button>
    </ng-container>
</div>
